module.exports = __webpack_public_path__ + "static/media/058-The Lazy Flamingo.713bdf0d.png";